/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_BodyInputs */

const en_mail_compose_body = /** @type {(inputs: Mail_Compose_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const de_mail_compose_body = /** @type {(inputs: Mail_Compose_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Mail_Compose_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_body = /** @type {((inputs?: Mail_Compose_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_body(inputs)
	return en_mail_compose_body(inputs)
});